import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import ADGMImage from '../ADGMImage';
import styles from './styles';
function NoData(props) {
  const { classes, headline, text } = props;

  return (
    <div className={classes.noDataContainer}>
      <ADGMImage className={classes.noDataIcon} name='NoData-Directory.svg' alt='no-data' />
      <Typography className={classes.headline}>{headline}</Typography>
      <Typography className={classes.text}>{text}</Typography>
    </div>
  );
}

NoData.propTypes = {
  classes: PropTypes.object.isRequired,
  headline: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
};

export default withStyles(styles)(NoData);
